import axios from 'axios'
import util from '@/libs/util'

// 生成小程序码。该接口返回图片二进制，因此不能走通用的业务响应拦截器。
export function generateMiniProgramQrCode (data) {
  const token = util.cookies.get('token')
  const headers = {}
  if (token && token !== 'undefined') {
    headers.Authorization = 'Bearer ' + token
  }
  return axios.post(
    process.env.VUE_APP_API + '/api/order/ar-msg-order/qrcode',
    data,
    {
      responseType: 'blob',
      headers
    }
  )
}
